var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconTypeTemplateLiteral(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "0.34885in",
    height: "0.276508in",
    viewBox: "0 0 86 68",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "black",
    strokeWidth: 5.12303,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "19,13 19,3 83,3 83,13"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "black",
    strokeWidth: 5.12303,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    x1: 51,
    y1: 3,
    x2: 51,
    y2: 65
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "black",
    strokeWidth: 5.12303,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    x1: 45,
    y1: 65,
    x2: 57,
    y2: 65
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 65,
    r: 3,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 65,
    r: 3,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 65,
    r: 3,
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTypeTemplateLiteral);
export default __webpack_public_path__ + "static/media/icon_type_template_literal.165b1cd20dea7ac5bcb2079c8468a18b.svg";
export { ForwardRef as ReactComponent };